import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { AccountService } from '../../../users/data/services/account.service';
import { Account } from '../../../users/data/types/account';
import { TokenStorageService } from 'src/app/core/service/token-storage.service';
import { ApiService } from 'src/app/authentication/otp/api.service';
import { LevelNameService } from 'src/app/authentication/otp/level-name.service'; // ✅ Import

@Component({
  selector: "app-gen-widgets",
  templateUrl: "./gen-widgets.component.html",
  styleUrls: ["./gen-widgets.component.sass"],
})
export class GenWidgetsComponent extends BaseComponent implements OnInit {
  activeAccounts: Account[] = [];
  parishId: any;

  groupsCount: number = 0;
  stationCount: number = 0;
  communityCount: number = 0;
  usersCount: number = 0;

  stationLabel: string = "Branch";
  communityLabel: string = "Sub Branch";
  hierarchyDepth: number = 3;

  constructor(
    private accountService: AccountService,
    private router: Router,
    private tokenStorage: TokenStorageService,
    private apiService: ApiService,                  
    private levelNameService: LevelNameService      
  ) {
    super();
  }

  ngOnInit(): void {
    this.fetchSubLevelNames(); 
    this.groups();
    this.station();
    this.community();
    this.users();
  }

  fetchSubLevelNames() {
  const parishId = this.tokenStorage.getUser()?.parishId;
  if (!parishId) return;

  this.apiService.getSubLevelNames(parishId)
    .pipe(takeUntil(this.subject))
    .subscribe({
      next: (res) => {
        this.levelNameService.updateLevelNames(res);
        this.hierarchyDepth = res.grandchildLevelName ? 3 : 2;
        this.stationLabel = res.childLevelName || "Branch";
        this.communityLabel = res.grandchildLevelName || "Sub-Branch";
      },
      error: (err) => {
        console.error('Error fetching level names:', err);
      }
    });
  }


  groups() {
    this.accountService.getAllGroups()
      .pipe(takeUntil(this.subject))
      .subscribe({
        next: (res) => (this.groupsCount = res?.entity?.length || res?.length || 0),
        error: (err) => console.error(err)
      });
  }

  station() {
    this.parishId = this.tokenStorage.getUser().parishId;
    this.accountService.getOutstation(this.parishId)
      .pipe(takeUntil(this.subject))
      .subscribe({
        next: (res) => {
          this.stationCount = res?.length || 0;
        },
        error: (err) => console.error(err)
      });
  }

  community() {
    this.parishId = this.tokenStorage.getUser().parishId;
    this.accountService.getAllCommunities(this.parishId)
      .pipe(takeUntil(this.subject))
      .subscribe({
        next: (res) => {
          this.communityCount = res?.length || 0;
        },
        error: (err) => console.error(err)
      });
  }

  users() {
    const parishId = this.tokenStorage.getUser().parishId;
    this.accountService.getSystemUsers(parishId)
      .pipe(takeUntil(this.subject))
      .subscribe({
        next: (res) => {
          this.usersCount = res?.entity?.length || 0;
        },
        error: (err) => console.error(err)
      });
  }

  viewGroups() {
    this.router.navigate(['/admin/groups/groups-details/']);
  }

  viewCommunity() {
    this.router.navigate(["/admin/community/communitydetails/"]);
  }

  viewUsers() {
    this.router.navigate(["admin/user-accounts/system-users/"]);
  }

  viewOutStations() {
    this.router.navigate(["/admin/outstation/"]);
  }
}
